export const CUSTOM_FOOTER_REFERENCE = [
    { id: 1, name: 'ODG Guidelines' },
    { id: 2, name: 'InnoviHealth Systems Inc - CPT(r) copyright American Medical' },
    { id: 3, name: 'Association' },
    { id: 4, name: 'FDA Guidelines' },
    { id: 5, name: 'National Vital Statistics United States' },
    { id: 6, name: 'Bureau of Statistics consumer price index United States Department of Health and Human Services' },
    { id: 7, name: 'Centers for Medicare and Medicaid Services' },
    { id: 8, name: 'Blue Book' },
    { id: 9, name: 'Redbook' },
    { id: 10, name: 'Usual and Customary Fee Schedule' },
    { id: 11, name: 'Federal Fee Schedule' },
];